import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilService {
  constructor() {
  }

  /*
    scroll on the container causes weird issue on dialog.
    removing it will disable the global scroll on page.
    and we can implement page level scroll.
  */
  hideScrollOnTopMostContainer() {
    const topmostContainer = document.querySelector('.topmost-container');
    if (topmostContainer && topmostContainer.classList) {
      topmostContainer.classList.add('hide-scroll');
    }
  }

  removeHideScrollClassFromTopMostContainer() {
    const topmostContainer = document.querySelector('.topmost-container');
    if (topmostContainer && topmostContainer.classList) {
      topmostContainer.classList.remove('hide-scroll');
    }
  }

  stopEventBubbling(event) {
    if (!event) {
      event = window.event;
    }
    event.cancelBubble = true;
    if (event.stopPropogation) {
      event.stopPropogation();
    }
  }

  removeQueryParam(entries = []) {
    const keys: any = {};
    const search = location.search.substring(1);
    try {
      if (search) {
        const params = JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}',
          function (key, value) { return key === '' ? value : decodeURIComponent(value); }
        );

        let foundAnyEntry = false;
        entries.forEach(entry => {
          if (params[entry]) {
            foundAnyEntry = true;
            keys[entry] = params[entry];
            delete params[entry];
          }
        });

        if (!foundAnyEntry) {
          return;
        }
        let href = this.jsonToQueryString(params);
        href = href !== '?' ? href : '';

        window.history.replaceState(
          {},
          document.title,
          window.location.pathname + href
        );
      }
    } catch (e) {
      console.error('could not remove param ', e);
      // do nothing
    }
  }

  jsonToQueryString(json) {
    return '?' +
      Object.keys(json).map(function (key) {
        return encodeURIComponent(key) + '=' +
          encodeURIComponent(json[key]);
      }).join('&');
  }
}
